<template>
  <div class="container">
    <Search></Search>
    <TabBar :hideSecondMenu="true"></TabBar>
    <div class="intro">
      <div class="location">
        <img src="@assets/pc/images/home/location.png" alt="" />
      </div>
      <div class="detail">
        <div class="detail-title">元芝庄药业有限公司</div>
        <div class="detail-title--english">
          Yuanzhizhuang Pharmaceutical Comércio Limitada
        </div>
        <div class="detail-information">
          <div class="contact">
            <div class="contact-infor">
              <span>+电话:</span>
              <span>厦门：0592-5911769</span>
            </div>
            <div class="contact-infor">
              <span>+QQ:</span>
              <span>2938260539</span>
            </div>
            <div class="contact-infor">
              <span>+微信:</span>
              <span>13055430992</span>
            </div>
            <div class="contact-infor">
              <span>+邮箱:</span>
              <span>2938260539@qq.com</span>
            </div>
            <div class="contact-infor">
              <span>营业执照:</span>
              <span class="on" @click="modal1 = true">点击查看</span>
            </div>
          </div>
          <div class="weixin-code">
            <img src="@assets/pc/images/home/serve.jpg" alt="" />
            <span>微信二维码</span>
          </div>
        </div>
        <div class="detail-simple">
          <div class="detail-simple--title">公司简介</div>
          <div class="detail-simple--content">
            元芝庄药业有限公司（Yuanzhizhuang Pharmaceutical Comércio
            Limitada）是经中国政府卫生局注册成立的专业药品销售商。自公司创立以来，元芝庄药业从最初单一的贸易结构逐步转变为现在多元化、规模化、科学化、系统化的新型贸易服务产业。不断为上下游客户提供品牌、市场、网络、信息等多层面的增值服务，是国内外上百家医药企业不可或缺的重要贸易桥梁。
          </div>
        </div>
      </div>
    </div>
    <Modal v-model="modal1" title="营业执照" @on-ok="modal1 = false">
      <img class="code" src="@/assets/pc/images/certificate/2.png" alt="" />
    </Modal>
  </div>
</template>

<script>
import Search from "@/components/pc/Search";
import TabBar from "@/components/pc/nav/TabBar";
export default {
  name: "ContactUs",
  components: {
    Search,
    TabBar
  },
  data() {
    return {
      modal1: false
    };
  }
};
</script>

<style lang="stylus" scoped>
.container
  background #fff
  .intro
    padding 50px 0 30px 230px
    display flex
    .location
      width 30px
      height 30px
      margin-top 5px
      img
        width 100%
        height 100%
    .detail
      margin-left 20px
      color #333
      &-title
        font-size 18px
        font-weight 700
        color #444
        &--english
          color #999
          width 420px
          border-bottom 1px solid #ccc
          padding 5px 0 10px
      &-information
        margin-top 15px
        display flex
        .contact
          width 600px
          .contact-infor
            display flex
            color #333
            font-size 15px
            height 30px
            line-height 30px
            span:first-child
              width 75px
            .on
              color #3487e6
              cursor pointer
        .weixin-code
          display flex
          flex-direction column
          margin-top 30px
          img
            width 100px
            height 100px
          span
            text-align center
            margin-top 10px
            color #999
            font-size 14px
      &-simple
        margin-top 50px
        &--title
          font-size 18px
          height 36px
          font-weight 700
          color #444
        &--content
          text-indent 2em
          font-size 15px
          color #999
          width 615px
.code
  width 100%
</style>
